import { z } from 'zod';

export const SigninSchema = z.object({
    email: z
        .string()
        .email({ message: 'Email address is required.' })
        .min(1, { message: 'Email address is required.' }),
    password: z.string().min(1, { message: 'Password is required.' }),
});

export type SigninFormType = z.infer<typeof SigninSchema>;
